export default {
    default: 'HTTP Error ',
    502: 'application servers is out',
    404: 'application can\'t resolve required data, looks like system error',
};
